/**
 * Bilingual Language Map for Horoscope Casting & Matching
 * Supports Tamil (ta) and English (en) output
 */

export type HoroscopeLang = 'ta' | 'en';

export const LANG = {
  ta: {
    NAKSHATRAS: [
      'அஸ்வினி', 'பரணி', 'கிருத்திகை', 'ரோகிணி', 'மிருகசீரிடம்', 'திருவாதிரை', 'புனர்பூசம்',
      'பூசம்', 'ஆயில்யம்', 'மகம்', 'பூரம்', 'உத்திரம்', 'ஹஸ்தம்', 'சித்திரை',
      'சுவாதி', 'விசாகம்', 'அனுஷம்', 'கேட்டை', 'மூலம்', 'பூராடம்', 'உத்திராடம்',
      'திருவோணம்', 'அவிட்டம்', 'சதயம்', 'பூரட்டாதி', 'உத்திரட்டாதி', 'ரேவதி'
    ],
    RASIS: [
      'மேஷம்', 'ரிஷபம்', 'மிதுனம்', 'கடகம்', 'சிம்மம்', 'கன்னி',
      'துலாம்', 'விருச்சிகம்', 'தனுசு', 'மகரம்', 'கும்பம்', 'மீனம்'
    ],
    RASIS_SHORT: ['மேஷ', 'ரிஷ', 'மிது', 'கடக', 'சிம்', 'கன்', 'துலா', 'விரு', 'தனு', 'மகர', 'கும்', 'மீன'],
    PLANETS: {
      SURY: 'சூரி', CHAN: 'சந்', KUJA: 'செவ்', BUDH: 'புத', GURU: 'குரு',
      SUKR: 'சுக்', SANI: 'சனி', RAHU: 'ராகு', KETU: 'கேது', LAGN: 'லக்',
      GULI: 'குளி', URAN: 'யுரே', NEPT: 'நெப்', PLUT: 'புளு'
    },
    PLANETS_FULL: {
      SURY: 'சூரியன்', CHAN: 'சந்திரன்', KUJA: 'செவ்வாய்', BUDH: 'புதன்', GURU: 'குரு',
      SUKR: 'சுக்கிரன்', SANI: 'சனி', RAHU: 'ராகு', KETU: 'கேது', LAGN: 'லக்னம்',
      GULI: 'குளிகன்', URAN: 'யுரேனஸ்', NEPT: 'நெப்டியூன்', PLUT: 'புளூட்டோ'
    },
    WEEKDAYS: ['ஞாயிறு', 'திங்கள்', 'செவ்வாய்', 'புதன்', 'வியாழன்', 'வெள்ளி', 'சனி'],
    THITHIS: [
      'பிரதமை', 'துவிதியை', 'திருதியை', 'சதுர்த்தி', 'பஞ்சமி', 'சஷ்டி', 'சப்தமி',
      'அஷ்டமி', 'நவமி', 'தசமி', 'ஏகாதசி', 'துவாதசி', 'திரயோதசி', 'சதுர்த்தசி', 'பௌர்ணமி',
      'பிரதமை', 'துவிதியை', 'திருதியை', 'சதுர்த்தி', 'பஞ்சமி', 'சஷ்டி', 'சப்தமி',
      'அஷ்டமி', 'நவமி', 'தசமி', 'ஏகாதசி', 'துவாதசி', 'திரயோதசி', 'சதுர்த்தசி', 'அமாவாசை'
    ],
    YOGAS: [
      'விஷ்கம்பம்', 'பிரீதி', 'ஆயுஷ்மான்', 'சௌபாக்யம்', 'சோபனம்', 'அதிகண்டம்', 'சுகர்மா',
      'திருதி', 'சூலம்', 'கண்டம்', 'விருத்தி', 'த்ருவம்', 'வியாகாதம்', 'ஹர்ஷணம்', 'வஜ்ரம்',
      'சித்தி', 'வியதீபாதம்', 'வரீயான்', 'பரிகம்', 'சிவம்', 'சித்தம்', 'சாத்யம்',
      'சுபம்', 'சுக்லம்', 'பிரம்மம்', 'இந்திரம்', 'வைத்ருதி'
    ],
    KARANAS: [
      'பவம்', 'பாலவம்', 'கௌலவம்', 'தைதுலம்', 'கரம்', 'வணிஜம்', 'விஷ்டி',
      'சகுனி', 'சதுஷ்பாதம்', 'நாகம்', 'கிம்ஸ்துக்னம்'
    ],
    PAKSHA: { SUKLA: 'சுக்ல', KRISHNA: 'கிருஷ்ண' },
    TAMIL_YEARS: [
      'பிரபவ', 'விபவ', 'சுக்ல', 'பிரமோதூத', 'பிரஜோத்பத்தி', 'ஆங்கீரச', 'ஸ்ரீமுக',
      'பவ', 'யுவ', 'தாது', 'ஈஸ்வர', 'பஹுதான்ய', 'பிரமாதி', 'விக்ரம', 'விஷு',
      'சித்திரபானு', 'சுபானு', 'தாரண', 'பார்த்திப', 'வியய', 'சர்வஜித்', 'சர்வதாரி',
      'விரோதி', 'விக்ருதி', 'கர', 'நந்தன', 'விஜய', 'ஜய', 'மன்மத', 'துன்முகி',
      'ஹேவிளம்பி', 'விளம்பி', 'விக்ராதி', 'சார்வரி', 'பிலவ', 'சுபகிருத்', 'சோபகிருத்',
      'குரோதி', 'விஸ்வாவசு', 'பரபாவ', 'பிலவங்க', 'கீலக', 'சௌம்ய', 'சாதாரண',
      'விரோதிகிருத்', 'பரிதாபி', 'பிரமாதீச', 'ஆனந்த', 'ராக்ஷச', 'நள', 'பிங்கள',
      'காளயுக்தி', 'சித்தார்த்தி', 'ரௌத்ரி', 'துன்மதி', 'துந்துபி', 'ருத்ரோத்காரி',
      'ரக்தாக்ஷி', 'குரோதன', 'அக்ஷய'
    ],
    TAMIL_MONTHS: [
      'சித்திரை', 'வைகாசி', 'ஆனி', 'ஆடி', 'ஆவணி', 'புரட்டாசி',
      'ஐப்பசி', 'கார்த்திகை', 'மார்கழி', 'தை', 'மாசி', 'பங்குனி'
    ],
    // Headers & Labels
    HOROSCOPE_OF: 'ஜாதகம்',
    BORN: 'பிறந்தது',
    SUNRISE_SET: 'உதய/அஸ்த',
    SIDEREAL_TIME: 'நக்ஷத்ர காலம்',
    AYANAMSA: 'அயனாம்சம்',
    STAR: 'நக்ஷத்ரம்',
    PADA: 'பாதம்',
    THITHI_LABEL: 'திதி',
    YOGA_LABEL: 'யோகம்',
    KARANA_LABEL: 'கரணம்',
    NIRAYANA: 'நிராயண தீர்க்காம்சம்',
    PLANET: 'கிரகம்',
    DEGREE: 'பாகை',
    RULER: 'அதிபதி',
    RETROGRESSION: 'வக்ரமாக உள்ள கிரகங்கள்',
    RASI_LABEL: 'ராசி',
    NAVAMSA_LABEL: 'நவாம்சம்',
    BHAVA_LABEL: 'பாவ',
    DASA_REMAINING: 'பிறப்பின்போது மீதமுள்ள தசை',
    YEARS: 'வருடம்', MONTHS_LABEL: 'மாதம்', DAYS_LABEL: 'நாள்',
    DASA: 'தசை', BUKTHI: 'புக்தி',
    DASA_ENDS: 'தசை முடிவு',
    BUKTHI_ENDS: 'புக்தி முடிவு',
    RUNNING: 'நடப்பு',
    TILL: 'வரை',
    ASHTAKAVARGA: 'அஷ்டகவர்க்கம்',
    PINDAS: 'பிண்டம்',
    TRIKONASODHANA: 'திரிகோணசோதனை',
    TOTAL: 'மொத்தம்',
    EXALTATION: 'உச்சம்',
    DEBILITATION: 'நீசம்',
    SHADBALA: 'ஷட்பலம்',
    DAY: 'பகல்', NIGHT: 'இரவு',
    PAGE: 'பக்கம்',
    // Matching labels
    HOROSCOPE_MATCHING: 'ஜாதகப் பொருத்தம்',
    BOY: 'ஆண்', GIRL: 'பெண்',
    NAME: 'பெயர்',
    PLACE_OF_BIRTH: 'பிறந்த இடம்',
    DATE_TIME: 'தேதி & நேரம்',
    NAKSHATRA_LABEL: 'நக்ஷத்ரம்',
    PORUTHAMS: 'பொருத்தங்கள்',
    MATCH: 'பொருத்தம்',
    POINTS: 'மதிப்பு',
    GOOD: 'நல்லது', FAIR: 'சரி', POOR: 'இல்லை',
    DOSHA_SAMYA: 'தோஷ சாம்யம்',
    DASA_SANDHI: 'தசா சந்தி',
    DASA_SANDHI_OCCUR: 'தசா சந்தி உள்ளது',
    DASA_SANDHI_NOT: 'தசா சந்தி இல்லை. ஏற்கத்தக்கது',
    RESULT: 'முடிவு',
    RESULT_GOOD: 'ஜாதகப் பொருத்தம் எல்லா வகையிலும் நன்றாக உள்ளது.',
    RESULT_FAIR: 'ஜாதகப் பொருத்தம் பொதுவாக நன்றாக உள்ளது.',
    RESULT_POOR: 'ஜாதகப் பொருத்தத்தில் சில பொருத்தமின்மைகள் உள்ளன.',
    PORUTHAM_NAMES: ['தினம்', 'கணம்', 'மகேந்திரம்', 'ஸ்த்ரீ தீர்க்கம்', 'யோனி', 'ராசி', 'ராசியாதிபதி', 'வச்யம்', 'ரஜ்ஜு', 'வேதை', 'வர்ணம்', 'நாடி'],
    GANAM_NAMES: ['தேவ', 'மனுஷ்ய', 'ராக்ஷச'],
    RAJJU_NAMES: ['பாதம்', 'கடி', 'ஊரு', 'கண்டம்', 'சிரோ'],
    VARNA_NAMES: ['பிராமண', 'க்ஷத்ரிய', 'வைஷ்ய', 'சூத்ர'],
    NADI_NAMES: ['இடம்', 'நடு', 'வலம்'],
  },
  en: {
    NAKSHATRAS: [
      'ASWINI', 'BHARANI', 'KRITHIKA', 'ROHINI', 'MRIGASIR', 'ARDRA', 'PUNARVAS',
      'PUSHYAMI', 'ASHLESHA', 'MAKHA', 'PUBBA', 'UTTARA', 'HASTA', 'CHITRA',
      'SWATHI', 'VISAKHA', 'ANURADHA', 'JYESHTA', 'MOOLA', 'PURVASHD', 'UTRASADA',
      'SHRAVANA', 'DHANISTA', 'SATABISA', 'PURVBDRA', 'UTRABDRA', 'REVATHI'
    ],
    RASIS: [
      'MESHA', 'RISHABA', 'MITHUNA', 'KATAKA', 'SIMHA', 'KANYA',
      'THULA', 'VRICHIK', 'DHANUS', 'MAKARA', 'KUMBHA', 'MEENA'
    ],
    RASIS_SHORT: ['MESH', 'RISH', 'MITH', 'KATA', 'SIMH', 'KANY', 'THUL', 'VRCH', 'DHAN', 'MAKR', 'KUMB', 'MEEN'],
    PLANETS: {
      SURY: 'SUR', CHAN: 'CHA', KUJA: 'KUJ', BUDH: 'BUD', GURU: 'GUR',
      SUKR: 'SUK', SANI: 'SAN', RAHU: 'RAH', KETU: 'KET', LAGN: 'LAG',
      GULI: 'GUL', URAN: 'URA', NEPT: 'NEP', PLUT: 'PLU'
    },
    PLANETS_FULL: {
      SURY: 'SURY', CHAN: 'CHAN', KUJA: 'KUJA', BUDH: 'BUDH', GURU: 'GURU',
      SUKR: 'SUKR', SANI: 'SANI', RAHU: 'RAHU', KETU: 'KETU', LAGN: 'LAGN',
      GULI: 'GULI', URAN: 'URAN', NEPT: 'NEPT', PLUT: 'PLUT'
    },
    WEEKDAYS: ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'],
    THITHIS: [
      'PRATHAMA', 'DWITHIYA', 'THRITHIYA', 'CHATHURTH', 'PANCHAMI', 'SASHTI', 'SAPTHAMI',
      'ASHTAMI', 'NAVAMI', 'DASAMI', 'EKADASI', 'DWADASI', 'THRAYODAS', 'CHATHURDA', 'POURNAMI',
      'PRATHAMA', 'DWITHIYA', 'THRITHIYA', 'CHATHURTH', 'PANCHAMI', 'SASHTI', 'SAPTHAMI',
      'ASHTAMI', 'NAVAMI', 'DASAMI', 'EKADASI', 'DWADASI', 'THRAYODAS', 'CHATHURDA', 'AMAVASYA'
    ],
    YOGAS: [
      'VISHKAMB', 'PREETHI', 'AYUSHMAN', 'SOWBAGYA', 'SOBHANA', 'ATHIGAND', 'SUKARMA',
      'DHRITHI', 'SOOLA', 'GANDA', 'VRIDHI', 'DHRUVA', 'VYAGATHA', 'HARSHANA', 'VAJRA',
      'SIDDHI', 'VYATHIPA', 'VARIYAN', 'PARIGHA', 'SIVA', 'SIDDHA', 'SADHYA',
      'SUBHA', 'SUKLA', 'BRAHMA', 'INDRA', 'VAIDHRIT'
    ],
    KARANAS: [
      'BAVA', 'BALAVA', 'KAULAVA', 'THYTHULA', 'GARAJA', 'VANIJA', 'VISHTI',
      'SAKUNI', 'CHATHUSHP', 'NAGA', 'KIMSTUGN'
    ],
    PAKSHA: { SUKLA: 'SUKLA', KRISHNA: 'KRISHNA' },
    TAMIL_YEARS: [
      'PRABHAVA', 'VIBHAVA', 'SUKLA', 'PRAMODOOTA', 'PRAJOTHPATTI', 'AANGIRASA', 'SRIMUKHA',
      'BHAVA', 'YUVA', 'DHAATU', 'ESWARA', 'BAHUDANYA', 'PRAMATHI', 'VIKRAMA', 'VISHU',
      'CHITRABAANU', 'SUBHAANU', 'TAARANA', 'PAARTHIBA', 'VYAYA', 'SARVAJIT', 'SARVADHARI',
      'VIRODHI', 'VIKRUTHI', 'KARA', 'NANDANA', 'VIJAYA', 'JAYA', 'MANMATHA', 'DUNMUKHI',
      'HEVILAMBI', 'VILAMBI', 'VIKRATHI', 'SARVARI', 'PLAVA', 'SUBAKRIT', 'SOBAKRIT',
      'KRODHI', 'VISWAVASU', 'PARABHAVA', 'PLAVANGA', 'KEELAKA', 'SOWMIYA', 'SADHARANA',
      'VIRODHIKRIT', 'PARIDHABI', 'PRAMADICHA', 'ANANDA', 'RAKSHASA', 'NALA', 'PINGALA',
      'KALAYUKTHI', 'SIDDHARTHI', 'RAUDRI', 'DUNMATHI', 'DUNDUBHI', 'RUDHRODGARI',
      'RAKTAKSHI', 'KRODHANA', 'AKSHAYA'
    ],
    TAMIL_MONTHS: [
      'CHITHIRAI', 'VAIKASI', 'AANI', 'AADI', 'AAVANI', 'PURATTASI',
      'AIPPASI', 'KARTHIGAI', 'MARGAZHI', 'THAI', 'MASI', 'PANGUNI'
    ],
    HOROSCOPE_OF: 'HOROSCOPE OF',
    BORN: 'BORN',
    SUNRISE_SET: 'SUNRISE/SET',
    SIDEREAL_TIME: 'SIDEREAL TIME',
    AYANAMSA: 'AYANAMSA',
    STAR: 'STAR', PADA: 'PADA',
    THITHI_LABEL: 'THITHI', YOGA_LABEL: 'YOGA', KARANA_LABEL: 'KARANA',
    NIRAYANA: 'NIRAYANA LONGITUDES',
    PLANET: 'PLANET', DEGREE: 'DEG:MN', RULER: 'RULER',
    RETROGRESSION: 'PLANETS UNDER RETROGRESSION',
    RASI_LABEL: 'R A S I', NAVAMSA_LABEL: 'NAVAMSA', BHAVA_LABEL: 'B A V A',
    DASA_REMAINING: 'DASA REMAINING AT TIME OF BIRTH',
    YEARS: 'YEARS', MONTHS_LABEL: 'MONTHS', DAYS_LABEL: 'DAYS',
    DASA: 'DASA', BUKTHI: 'BUKTHI',
    DASA_ENDS: 'DASA ENDS', BUKTHI_ENDS: 'BUKTHI ENDS',
    RUNNING: 'IS RUNNING', TILL: 'TILL',
    ASHTAKAVARGA: '*** ASHTAGA VARGA ***',
    PINDAS: '* PINDAS *',
    TRIKONASODHANA: '*** TRIKONASODHANA ***',
    TOTAL: 'TOTAL',
    EXALTATION: 'EXALTATION', DEBILITATION: 'DEBILITATION',
    SHADBALA: '*** SHADBALA - STHANABALA ***',
    DAY: 'DAY', NIGHT: 'NIGHT', PAGE: 'PAGE',
    HOROSCOPE_MATCHING: 'HOROSCOPE MATCHING',
    BOY: 'BOY', GIRL: 'GIRL',
    NAME: 'NAME', PLACE_OF_BIRTH: 'PLACE OF BIRTH', DATE_TIME: 'DATE & TIME',
    NAKSHATRA_LABEL: 'NAKSHATRA',
    PORUTHAMS: 'PORUTHAMS',
    MATCH: 'MATCH', POINTS: 'POINTS',
    GOOD: 'GOOD', FAIR: 'FAIR', POOR: 'POOR',
    DOSHA_SAMYA: 'DOSHA SAMYAS',
    DASA_SANDHI: 'DASA SANDHI',
    DASA_SANDHI_OCCUR: 'DASA SANDHI OCCURS,BUT NO BUKTHI SANDHI;OK',
    DASA_SANDHI_NOT: 'DASA SANDHI DOES NOT OCCUR. ACCEPTABLE',
    RESULT: 'Result',
    RESULT_GOOD: 'The Jadhaka Porutham is found good in all respect.',
    RESULT_FAIR: 'The Jadhaka Porutham is found generally good.',
    RESULT_POOR: 'The Jadhaka Porutham shows some incompatibilities.',
    PORUTHAM_NAMES: ['DINA', 'GANA', 'MAHENDRA', 'STHREE DHIRGA', 'YONI', 'RASI', 'ADIPATHY', 'VASYA', 'RAJJU', 'VEDHA', 'VARNA', 'NADI'],
    GANAM_NAMES: ['DEVA', 'MANUSHYA', 'RAKSHASA'],
    RAJJU_NAMES: ['PADA', 'KATI', 'URU', 'KANDA', 'SIRO'],
    VARNA_NAMES: ['BRAHMIN', 'KSHATRIA', 'VAISHYA', 'SHUDRA'],
    NADI_NAMES: ['LEFT', 'CENTRAL', 'RIGHT'],
  }
};

/** Helper: get lang dict */
export function getLangDict(lang: HoroscopeLang) {
  return LANG[lang] || LANG.en;
}
